<template>
  <div class="card-view " :class="[{'no-padding const-height' : campaign}]">
    <slot v-if="campaign">

    </slot>
    <div class="card-inner" v-else>
      <div class="icon-container" >
        <slot></slot>
      </div>
      <div class="text-container">
        <div class="card-title">{{ title }}</div>
        <div class="card-data">{{ data }}</div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Card',
  props: ['title', 'data', 'campaign'],
};
</script>

<style scoped lang="scss">
  div.card-view {
    width: 100%;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.08);
    position: relative;
    overflow: hidden;
    transition: all ease 0.5s;


    &.no-padding {
      padding: 0;
    }

    &.const-height {
      height: 96px;
      overflow: hidden;

      img{
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }

    &:hover {
      box-shadow: 0 4px 16px rgba($color: #000000, $alpha: 0.08);
      transition: all ease 0.5s;
    }

    div.card-inner {
      display: flex;
      color: #FFF;
      align-items: center;

      div.card-title {
        flex: 1;
        font-weight: 700;
        font-size: 13px;
        text-transform: uppercase;
      }

      div.card-data {
        display: block;
        font-weight: 400;
        font-size: 16px;
      }
    }

    div.icon-container {
      float: left;
      margin-right: 10px;
      width: 48px;
      height: 48px;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba($color: #FFF, $alpha: 0.25);

      transition: all ease 0.5s;

      svg {
        color: rgba($color: #FFF, $alpha: 1);
        width: 24px;
        height: 24px;
      }
    }
  }

</style>
